import React, { useState } from 'react';
import {
    AllocationsByClientExportCard,
    AllocationsListExportCard,
    CollaboratorsExportCard,
    CollaboratorsListExportCard,
    DeveloperHoursExportCard,
} from './components';

/**
 * Central de exportações administrativas. O acesso é restrito a admin pela
 * rota `/admin/exports` (ROLE_COMBINATIONS.ADMIN_ONLY em AdminRoutes).
 */
export default function ExportsPage() {
    const [error, setError] = useState<string | null>(null);

    return (
        <div className="container mx-auto space-y-6 p-4">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-900">Exportações</h2>
            </div>

            {error && (
                <div
                    className="relative rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
                    role="alert"
                >
                    <strong className="font-bold">Erro: </strong>
                    <span className="block sm:inline">{error}</span>
                </div>
            )}

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                <CollaboratorsExportCard onError={setError} />
                <CollaboratorsListExportCard onError={setError} />
                <AllocationsByClientExportCard onError={setError} />
                <AllocationsListExportCard onError={setError} />
                <DeveloperHoursExportCard onError={setError} />
            </div>
        </div>
    );
}
